<script>
	import { onMount } from 'svelte';
	import { useStoryblokBridge, StoryblokComponent } from '@storyblok/svelte';
	import NotificationBanner from '$lib/cms/notification-banner.svelte';

	export let data;

	onMount(() => {
		useStoryblokBridge(data.story.id, (newStory) => (data.story = newStory), {
			// resolveRelations: ['Article.author'],
			resolveLinks: 'url'
		});
	});
	$: slug = data.story?.full_slug == 'home' ? '' : data.story?.full_slug;
	$: name = 'ContentFries - ' + data.story?.name;
</script>

<NotificationBanner />
<div>
	{#if data.story}
		<StoryblokComponent
			{slug}
			{name}
			blok={data.story.content}
			footer={data.footer?.content}
			latestArticles={data.latestArticles}
		/>
	{/if}
</div>
